// extracted by mini-css-extract-plugin
export default {"app-layout":"rArp1pK_qU0xfsuGLF6s","appLayout":"rArp1pK_qU0xfsuGLF6s"};